import { render, staticRenderFns } from "./ContentEdit.vue?vue&type=template&id=68304f6a&"
import script from "./ContentEdit.vue?vue&type=script&lang=js&"
export * from "./ContentEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports